<div class="top-part">
  <h2 mat-dialog-title class="web-account-title" (click)="betaSettings()" [attr.title]="!environment.production ? 'Click to navigate to Beta Settings' : 'Your account'" [ngClass]="{'clickable' : !environment.production}" >
    Your Account
    <span *ngIf="isAccountRegionShown" class="delete-button" (click)="$event.stopPropagation(); deleteAccClick()">Delete</span>
  </h2>
  <div class="profile-wrapper">
    <div class="profile-region" >

    <div class="region-head" fxLayout="row" (click)="toggleRegion($event, PROFILE_REGION.RENDER_LIMIT)" fxLayoutAlign="space-between center" >
      <h2 class="region-title" [ngClass]="{'expanded': isRenderLimitRegionShown}" (click)="toggleRegion($event, PROFILE_REGION.RENDER_LIMIT)">Billing</h2>
      <svg *ngIf="!isRenderLimitRegionShown" class="arrow-right"  width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="toggleRegion($event, PROFILE_REGION.RENDER_LIMIT)">
        <path d="M0.75 0.75L5.75 7L0.75 13.25" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" (click)="toggleRegion($event, PROFILE_REGION.PERSONAL)"/>
      </svg>
      <svg *ngIf="isRenderLimitRegionShown" class="arrow-down"  width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="toggleRegion($event, PROFILE_REGION.RENDER_LIMIT)" >
        <path d="M13.25 0.75L7 5.75L0.75 0.75" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" (click)="toggleRegion($event, PROFILE_REGION.PERSONAL)" />
      </svg>
    </div>

      <ng-container  #renderLimitRegion *ngIf="this.isRenderLimitRegionShown"  >
        <div class="profile-section" fxLayout="column"  [@slideToggle]="isRenderLimitRegionShown">
            <!-- Show upload count only for TRIAL users -->
            <div class="top-level-zone" *ngIf="isTrial()" fxFlex="1 1 36px" fxLayout="row" fxLayoutAlign="space-between center">
              <div class="left-info">
                <h3>{{getUploadsLeft()}}</h3>
                <p>{{getUploadsLeft() === 1 ? 'upload' : 'uploads'}} left during free trial</p>
              </div>
              <div class="right-price">
                <!-- <h4>$4.99</h4><p class="small">per upload</p> -->
              </div>
            </div>
            <!-- Show trial expired message for TRIAL_EXPIRED users -->
            <!-- <div class="top-level-zone" *ngIf="isTrialExpired()" fxFlex="1 1 36px" fxLayout="row" fxLayoutAlign="space-between center">
              <div class="left-info">
                <p>Your free trial has expired</p>
              </div>
            </div> -->
            <button *ngIf="isSubscriber() && !firebaseAuth.currentUser.isAutoRenewDisabled" [disabled]="firebaseAuth.isSubscriptionRelatedBtnDisabled" class="close-acc-btn" (click)="cancelSub()">
              <span>Cancel Auto Renew</span>
            </button>
            <button *ngIf="!isSubscriber() && !isExpired()" [disabled]="firebaseAuth.isSubscriptionRelatedBtnDisabled" class="close-acc-btn" (click)="subscribe()">
              <span>Join Membership</span>
            </button>
            <button *ngIf="isExpired()" [disabled]="firebaseAuth.isSubscriptionRelatedBtnDisabled" class="close-acc-btn" (click)="subscribe()">
              <span>Join Membership</span>
            </button>
            <button *ngIf="isSubscriber() && firebaseAuth.currentUser.isAutoRenewDisabled" [disabled]="firebaseAuth.isSubscriptionRelatedBtnDisabled" class="close-acc-btn" (click)="renew()">
              <span class="renew-label">Renew: $65/year</span>
              <span class="renewal-date" *ngIf="getSubscriptionRenewalDate()">Starting {{ getSubscriptionRenewalDate() }}</span>
            </button>
            <p class="subscription-end-label" *ngIf="isSubscriptionEndLabelShown()">
              If you cancel now, you can still access your membership until {{ getFormattedEndDate() }}
            </p>
            <p class="subscription-end-label" *ngIf="firebaseAuth.currentUser?.subscriptionEndDateTime && firebaseAuth.currentUser?.isAutoRenewDisabled && !isExpired()">
              <span class="red-label">You are no longer enrolled in Membership Auto Renew.</span> <br>
              Active membership till {{ getFormattedEndDate() }}
            </p>
            <p class="subscription-end-label" *ngIf="isExpired() && firebaseAuth.currentUser?.subscriptionEndDateTime">
              <span class="red-label">You have cancelled your membership.</span> <br>
              Your membership ended on {{ getFormattedEndDate() }}
            </p>
        <div class="profile-section-bottom-part" *ngIf="shouldShowRenderLimitSelector()" fxFlex="1 1 100" fxLayout="row" fxLayoutAlign="center center">
          <app-renderlimit-select style="width: 347px; padding-top: 20px;" [isRenderLimitTitleShown]="true" (renderLimitChange)="onRenderLimitChanged($event)"></app-renderlimit-select>
        </div>
      </div>
    </ng-container>

      <div class="region-head" fxLayout="row" (click)="toggleRegion($event, PROFILE_REGION.PERSONAL)" fxLayoutAlign="space-between center" >
        <h2 class="region-title" [ngClass]="{'expanded': isAccountRegionShown}" (click)="toggleRegion($event, PROFILE_REGION.PERSONAL)">Account Management</h2>
        <svg *ngIf="!isAccountRegionShown" class="arrow-right"  width="7" height="14" viewBox="0 0 7 14" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="toggleRegion($event, PROFILE_REGION.PERSONAL)">
          <path d="M0.75 0.75L5.75 7L0.75 13.25" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" (click)="toggleRegion($event, PROFILE_REGION.PERSONAL)"/>
        </svg>
        <svg *ngIf="isAccountRegionShown" class="arrow-down"  width="14" height="7" viewBox="0 0 14 7" fill="none" xmlns="http://www.w3.org/2000/svg" (click)="toggleRegion($event, PROFILE_REGION.PERSONAL)" >
          <path d="M13.25 0.75L7 5.75L0.75 0.75" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" (click)="toggleRegion($event, PROFILE_REGION.PERSONAL)" />
        </svg>
      </div>
      <ng-container #profileRegion *ngIf="this.isAccountRegionShown"  >
          <div class="profile-section" fxLayout="column" [@slideToggle]="isAccountRegionShown">
            <div class="profile-section-item" fxLayout="row" fxLayoutAlign="start center">
              <h2 class="menu-option" (click)="openTermsOfService()">Terms of Services</h2>
            </div>
            <div class="profile-section-item" fxLayout="row" fxLayoutAlign="start center">
              <h2 class="menu-option" (click)="openPrivacyPolicy()">Privacy Policy</h2>
            </div>
            <div class="profile-section-item" fxLayout="row" fxLayoutAlign="start center" *ngIf="isContentAdmin">
              <h2 class="menu-option" (click)="openContentAdmin()">Content Admin</h2>
            </div>
            <div class="profile-section-item" fxLayout="row" fxLayoutAlign="space-between center">
              <h2 class="menu-option" (click)="signOut()">Sign Out</h2>
              <span class="user-email" [title]="firebaseAuth.currentUser?.email" *ngIf="firebaseAuth.currentUser?.email">{{firebaseAuth.currentUser?.email}}</span>
            </div>
            <!-- <div class="profile-section-bottom-part" fxFlex="1 1 100" fxLayout="row" fxLayoutAlign="center center">
              <button class="close-acc-btn" (click)="deleteAccClick()">
                <span> Close my account and delete my data</span>
              </button>
            </div> -->
          </div>
      </ng-container>

    </div>

  </div>
</div>

<div class="bottom-part">
  <!-- Feedback area -->
  <div class="feedback-container">
    <div class="feedback-input-wrapper">
      <textarea
        class="feedback-input"
        placeholder="Type your idea or bug report..."
        [(ngModel)]="feedbackService.feedbackText"
        [disabled]="feedbackService.isSubmitting">
      </textarea>
    </div>
  </div>

  <mat-dialog-actions align="center">
    <button class="back-btn" mat-dialog-close [disabled]="feedbackService.isSubmitting">
      <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span class="web-btn-text">Back</span>
    </button>

    <button class="send-btn" [disabled]="!feedbackService.feedbackText.trim() || feedbackService.isSubmitting" (click)="submitFeedback()">
      <span>{{ feedbackService.isSubmitting ? 'Sending...' : 'Send' }}</span>
    </button>

    <!-- THIS IS DONE FOR PROPER ALIGNMENT IN A FAST WAY -->
    <button class="back-btn" [hidden]="true" style="visibility: hidden;">
      <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M10.9823 1.5L0.833008 10L10.9823 18.5" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <span class="web-btn-text">Back</span>
    </button>
  </mat-dialog-actions>
</div>

